import router from '@/router'

const getRouteQuery = () => {
  // console.log(router.app._route.query)
  const miniprogram_data = router.app._route.query.miniprogram_data
  
  if (miniprogram_data) {
    return {
      status: true,
      data: JSON.parse(miniprogram_data)
    }
  } else {
    return {
      status: false,
      data: {}
    }
  }
}

const sentPostMessage = ({ action, data, routerTo = '' }) => {
  const route = router.app._route
   uni.webView.postMessage({
     data: {
       action: action,
       data: data,
       routerFrom:
         routerTo !== '' ? routerTo : route.fullPath
     }
   })
  
    uni.webView.navigateBack({
      delta: 1
    })
}

const setAuth = ({ data, routerTo = '' }) => {
  sentPostMessage({
    action: 'setAuth',
    data: data,
    routerTo: routerTo
  })
}

const getAuth = ({ data = '', routerTo }) => {
  // console.log(routerTo, 'routerTo')
  const result = getRouteQuery()
  if (result.status) {
    return result.data
  } else {
    sentPostMessage({
      action: 'getAuth',
      routerTo: routerTo
    })
  }
}
const clearAuth = ({ data = '', routerTo }) => {
   sentPostMessage({
     action: 'clearAuth',
     routerTo: routerTo
   })
}
    

const getLocation = data => { }


const actionsMap = {
  setAuth: setAuth,
  getAuth: getAuth,
  getLocation: getLocation,
  clearAuth: clearAuth
}

function miniProgramDataHandle(data) {
  if (data.status) {
    const { action, data: data2 } = data.data
    actionsMap[action](data2)
  }
}

export default function weChatpostMessage(data) {
  return {
    ...actionsMap,
    miniProgramDataHandle: miniProgramDataHandle
  }
}


